import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Association, RegisterAssociation, UpdateAssociation } from "../models/association";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
  export class AssociationService {
  
    private baseUrl = `${environment.apiUrl}/associations`;

    constructor(private http: HttpClient) {}

    getAssociation(id: string): Observable<Association> {
      return this.http.get<Association>(`${this.baseUrl}/${id}`);
    }

    getAssociations(municipalityId: string): Observable<Association[]> {
      return this.http.get<Association[]>(`${this.baseUrl}/by-municipality/${municipalityId}`);
    }

    deleteAssociation(associationId: string): Observable<void> {
      return this.http.delete<void>(`${this.baseUrl}/${associationId}`);
    }

    updateAssociation(updateDto: UpdateAssociation): Observable<void> {
      return this.http.put<void>(`${this.baseUrl}/`, updateDto);
  }

    registerAssociation(registerDto: RegisterAssociation): Observable<void> {
      return this.http.post<void>(`${this.baseUrl}`, registerDto);
  }

  }